import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";

//API
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";

// import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";

//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  currencyFormat,
  formatDate,
  getTodaysData,
  // getTodaysData,
} from "../../../../common/Validations";
// import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  getBankStatement,
  getCashExpenses,
  getPoDeliverConfirmList,
} from "../../../../redux/feature/customer_app/customerSlice";
import { useNavigate } from "react-router-dom";
import CustomerConstants from "../../../../common/CustomerConstants";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import { Construction } from "lucide-react";

const DispatchPurchaseOrderModal = React.forwardRef((props, ref) => {
  console.log();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [getInvoiceinfo, setInvoiceinfo] = useState();
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  // console.log(">>getInvoiceinfo", getInvoiceinfo);
  // console.log(">>getDisabledStatus", getDisabledStatus);
  let userData = useSelector((state) => state?.user?.data);
  let grnNumber = useSelector(
    (state) => state?.customer?.pODeliverConfirm?.pODeliverConfirmNr
  );
  // console.log(">>grnNumber", grnNumber);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [cashRequest, setCashRequest] = useState({
    createdBy: userData?.userId || "",
    cashRequestNr: "",
    cashRequestStatus: "Cash in Transit",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: 0,
    cashAmountInWords: "",
    debitAmount: 0,
    creditAmount: 0,
    bankTransactionDate: "",
    customerBankName: "",
    customerBank: "",
    companyBank: "",
    companyBankName: "",
    receivedBy: userData?.firstName || "",
    receiverContactNumber: userData?.contactNumber || "",
    party: "Vendor",
    paymentType: "Purchase",
    type: "DEBIT",
    typeCode: "DEBIT",
    typeCodeDesc: "Payment",
  });

  const [getPaymentdisable, setPaymentdisable] = useState(false);
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getCustomer, setCustomer] = useState([]);
  const transactionType = [
    { id: 1, code: "NEFT", name: "NEFT", description: "NEFT" },
    { id: 2, code: "CHEQUE", name: "CHEQUE", description: "CHEQUE" },
    { id: 3, code: "RTGS", name: "RTGS", description: "RTGS" },
    { id: 4, code: "CASH", name: "CASH", description: "CASH" },
    { id: 5, code: "UPI", name: "UPI", description: "UPI" },
  ];
  const hide = true;
  const expenseData = [
    { id: 1, name: "Salary", description: "Salary", code: "SL" },
    { id: 2, name: "EV Charges", description: "EV Charges", code: "EC" },
    {
      id: 3,
      name: "Vehicle Repair and Maintanance",
      description: "Vehicle Repair and Maintanance",
      code: "VRM",
    },
    { id: 4, name: "Diesel", description: "Diesel ", code: "DE" },
    {
      id: 5,
      name: "Telephone and Mobile",
      description: "Telephone and Mobile",
      code: "TMB",
    },
    { id: 6, name: "Miscellaneous", description: "Miscellaneous", code: "ME" },
    { id: 7, name: "Electrical", description: "Electrical", code: "EL" },
    { id: 8, name: "Raw Material", description: "Raw Material", code: "RM" },
    { id: 9, name: "Tails", description: "Tails", code: "TA" },
    { id: 10, name: "Doors", description: "Doors", code: "DO" },
    { id: 11, name: "Steel", description: "Steel", code: "ST" },
    { id: 13, name: "Cement", description: "Cement", code: "CE" },
    { id: 12, name: "Others", description: "Others", code: "OT" },
  ];
  useEffect(() => {
    if (props?.invoiceinfo) {
      const cloned = props.invoiceinfo.items.map((item) => ({
        ...item, // original properties
        invoiceQty: item.invoiceQty || "",
        invoicePrice: item.invoicePrice || "",
        invoiceTax: item.invoiceTax || "",
        invoiceValue: item.invoiceValue || 0,
        invoicetaxAmount: item.invoicetaxAmount || 0,
        // taxAmount: item.taxAmount || 0,
        // grossValue: item.grossValue || 0
      }));

      setInvoiceinfo(props.invoiceinfo);
      // props?.invoiceinfo?.payment
      const status = props?.invoiceinfo?.paymentStatus;

      // When Confirmed or Posted
      if (status === "Confirmed" || status === "Posted") {
        const payment = {
          ...props?.invoiceinfo?.payment,
          type: "DEBIT",
          typeCode: "DEBIT",
          typeCodeDesc: "Payment",
        };
        setCashRequest(payment);
        setPaymentdisable(true);
      } else {
        setPaymentdisable(false);
        setCashRequest({
          createdBy: userData?.userId || "",
          cashRequestNr: "",
          cashRequestStatus: "Cash in Transit",
          salesOfficerCode: "",
          salesOfficerName: "",
          customerCode: "",
          customerName: "",
          paymentPurpose: "",
          paymentMode: "",
          cashAmount: 0,
          cashAmountInWords: "",
          debitAmount: 0,
          creditAmount: 0,

          bankTransactionDate: "",
          customerBankName: "",
          customerBank: "",
          companyBank: "",
          companyBankName: "",
          receivedBy: userData?.firstName || "",
          receiverContactNumber: userData?.contactNumber || "",
          party: "Vendor",
          paymentType: "Purchase",
          type: "DEBIT",
          typeCode: "DEBIT",
          typeCodeDesc: "Payment",
        });
      }

      setDisabledStatus(
        (props?.invoiceinfo?.items[0]?.deliveryConfirm &&
          props?.invoiceinfo?.items[0]?.deliveryConfirm) ||
          false
      );
      setInvoiceItems(cloned);
      setSelectedRows([]);
    }
    // eslint-disable-next-line
  }, [props]);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const [disable, setDisabled] = useState(false);
  const [getSelectedRows, setSelectedRows] = useState([]);
  // console.log(">>getSelectedRows", getSelectedRows);
  const handleCheckboxChange = (index, isChecked) => {
    const updated = [...invoiceItems];

    // Update checkbox value
    updated[index].deliveryConfirm = isChecked;

    setInvoiceItems(updated);

    // Auto-select row when checked
    if (isChecked) {
      setSelectedRows((prev) => [...prev, updated[index]]);
    } else {
      // Remove from selectedRows when unchecked
      setSelectedRows((prev) =>
        prev.filter((row) => row.local_id !== updated[index].local_id)
      );
    }
  };

  // PO columns Details
  const columns = [
    {
      name: "PO Item Nr",
      selector: (row) => row.indentDocumentItemNr,
      sortable: true,
      width: "140px",
    },

    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    /*   {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    }, */
    {
      name: "Purchase Quantity",
      selector: (row) => row.indentQuantity,
      sortable: true,
      width: "180px",
    },
    //   {
    //   name: "Delivery Confirmed", //input field
    //   selector: (row) => row.indentQuantity,
    //   cell: (row, index) => (
    //     <InputField
    //       className="inputBox"
    //       type="deliveryConfirm"
    //       value={row.invoiceQty || ""}
    //       onChange={(e) =>
    //         handleInputChange(index, "invoiceQty", e.target.value)
    //       }
    //     />
    //   ),
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "Delivery Confirmed",
      selector: (row) => row.deliveryConfirm,
      cell: (row, index) => (
        <input
          type="checkbox"
          checked={row.deliveryConfirm || false}
          onChange={(e) => handleCheckboxChange(index, e.target.checked)}
          disabled={getDisabledStatus}
        />
      ),
      sortable: false,
      width: "160px",
    },

    {
      name: "Invoice Quantity", //input field
      selector: (row) => row.indentQuantity,
      cell: (row, index) => (
        <InputField
          className="inputBox"
          type="number"
          value={row.invoiceQty || ""}
          onChange={(e) =>
            handleInputChange(index, "invoiceQty", e.target.value)
          }
          disabled={getDisabledStatus}
        />
      ),
      sortable: true,
      width: "180px",
    },

    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.quotationUnitPrice,
      sortable: true,
      width: "120px",
    },
    {
      name: "Invoice Price", //input field
      selector: (row) => row.quotationUnitPrice,
      cell: (row, index) => (
        <InputField
          className="inputBox"
          type="number"
          value={row.invoicePrice || ""}
          onChange={(e) =>
            handleInputChange(index, "invoicePrice", e.target.value)
          }
          disabled={getDisabledStatus}
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Value", // calculate price x value
      selector: (row) => row.quotationUnitPrice,
      cell: (row) => (
        <InputField
          className="inputBox"
          value={row.invoiceValue || 0}
          disabled
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Tax %", // calculate  tax in percent
      selector: (row) => row.quotationUnitPrice,
      sortable: true,
      cell: (row, index) => (
        <InputField
          className="inputBox"
          type="number"
          value={row.invoiceTax || ""}
          onChange={(e) =>
            handleInputChange(index, "invoiceTax", e.target.value)
          }
          disabled={getDisabledStatus}
        />
      ),
      width: "130px",
    },
    {
      name: "Invoice Tax",
      selector: (row) => row?.invoicetaxAmount,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(Number(row?.invoicetaxAmount).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "140px",
    },
    {
      name: "Invoice Gross",
      selector: (row) => row?.invoiceGrossValueTaxAmount,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(
            Number(row?.invoiceGrossValueTaxAmount || 0).toFixed(2)
          ) || 0}
        </span>
      ),

      sortable: true,
      width: "140px",
    },
    {
      name: "Item Value",
      selector: (row) => row?.qtnitemValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(Number(row?.qtnitemValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "140px",
    },
    {
      name: "Tax %",
      selector: (row) => row.taxCode,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row?.taxAmount,
      sortable: true,
      width: "140px",
    },
    {
      name: "Gross Value",
      selector: (row) => row?.grossValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0  fw-bold">
          {currencyFormat(Number(row?.grossValue).toFixed(2))}
          {/* {row.grossValue} */}
        </span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Currency",
      selector: (row) => getInvoiceinfo?.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 ">{formatDate(row?.deliveryDate)} </p>
        </div>
      ),
      width: "160px",
    },
  ];

  const columnsService = [
    {
      name: "PO Number",
      //  selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            //  onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            //  onClick={() =>
            //    showServiceItemTable(row.services, row.purchasingDocumentItemNr)
            //  }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },

    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  const columnsSchedule = [
    {
      name: "PO Number",
      //  selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            //  onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Schedules",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            //  onClick={() =>
            //    showServiceItemTable(row.schedule, row.purchasingDocumentItemNr)
            //  }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currency,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  // PO items columns Details
  // const lineItemColInfo = [
  //   {
  //     name: "Code",
  //     cell: (row) => <span>{row.documentId} </span>,
  //     width: "200px",
  //   },
  //   {
  //     name: "Text",
  //     cell: (row) => <span>{row.documentText} </span>,
  //     width: "250px",
  //   },
  // ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
        setSelectedRows([]);
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
    setSelectedRows([]);
  };

  const totals = getSelectedRows.reduce(
    (acc, item) => {
      acc.totalInvoiceQty += Number(item.invoiceQty || 0);
      acc.totalInvoicePrice += Number(item.invoicePrice || 0);
      // acc.totalInvoiceTax += Number(item.invoiceTax || 0);
      acc.totalInvoiceValue += Number(item.invoiceValue || 0);
      acc.totalInvoicetaxAmount += Number(item.invoicetaxAmount || 0);
      acc.totalInvoiceGrossValueTaxAmount += Number(
        item.invoiceGrossValueTaxAmount || 0
      );
      return acc;
    },
    {
      totalInvoiceQty: 0,
      totalInvoicePrice: 0,
      totalInvoiceTax: 0,
      totalInvoiceValue: 0,
      totalInvoicetaxAmount: 0,
      totalInvoiceGrossValueTaxAmount: 0,
    }
  );

  // console.log(">>totals", totals);

  const handleSave = async () => {
    if (getSelectedRows.length === 0) {
      alert("Please select at least one Item!");
      return; // stop function
    }

    const obj = {
      data: {
        ...getInvoiceinfo,
        items: getSelectedRows,
        totalInvoiceQty: totals?.totalInvoiceQty,
        totalInvoicePrice: totals?.totalInvoicePrice,
        // totalInvoiceTax: totals?.totalInvoiceTax,
        totalInvoiceValue: totals?.totalInvoiceValue,
        totalInvoicetaxAmount: totals?.totalInvoicetaxAmount,
        totalInvoiceGrossValueTaxAmount:
          totals?.totalInvoiceGrossValueTaxAmount,
        deliveryStatus: "Deliverey Confirmed",
        deliveryConfirm: true,
      },
    };
    // console.log(">>obj", obj);
    setDisabled(true);
    await ItemServiceV2.addGRN(obj).then((item) => {
      if (item?.status === 200) {
        // handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        let obj = {
          queryName: "Get_CUST_Dispatch_List",
          // module: "PO",
          page: 1,
          per_page: 10,
        };
        dispatch(getPoDeliverConfirmList(obj));

        navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_CONFIRM);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const totalTaxAmount = getInvoiceinfo?.items?.reduce(
    (sum, item) => sum + (item.taxAmount || 0),
    0
  );
  const totalGrossValue = getInvoiceinfo?.items?.reduce(
    (sum, item) => sum + (item.grossValue || 0),
    0
  );
  const totalQtnItemValue = getInvoiceinfo?.items?.reduce(
    (sum, item) => sum + (item.qtnitemValue || 0),
    0
  );

  // const [getItemLevelData, setItemLevelData] = useState([]);
  // const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  // const [getModalTitle, setModalTitle] = useState("");
  // const [getViewHeaderText, setViewHeaderText] = useState(false);

  // OnClick on Header Text  Data
  // const headerTextShowModal = (headerTextData) => {
  //   setItemLevelData(headerTextData);
  //   setItemLevelColumns(lineItemColInfo);
  //   setModalTitle("Header Text Details");
  //   setViewHeaderText(true);
  // };
  // const headerTextHideModal = () => {
  //   setViewHeaderText(false);
  // };

  // const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  // const lineItemShowModal = (itemLevelData) => {
  //   setItemLevelData(itemLevelData);
  //   setItemLevelColumns(lineItemColInfo);
  //   setModalTitle("Item Text Details");
  //   setItemLevelModalShow(true);
  // };
  // const itemLevelHideModal = () => {
  //   setItemLevelModalShow(false);
  // };

  const handleSelectedRowsChange = ({ selectedRows }) => {
    const updated = selectedRows.map((row) => ({
      ...row,
      deliveryConfirm: true,
      deliveryStatus: "Delivered Confirmed",
    }));

    setSelectedRows(updated);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...invoiceItems];

    // For checkbox, value will be boolean, so skip Number()
    let newValue = field === "deliveryConfirm" ? value : Number(value);
    if (field === "invoiceQty") {
      const maxQty = Number(updated[index]?.indentQuantity || 0);

      if (newValue > maxQty) {
        newValue = maxQty;
      }
    }

    updated[index][field] = newValue;

    // Auto calculations (same as before)
    const price = Number(updated[index]?.invoicePrice || 0);
    const qty = Number(updated[index]?.invoiceQty || 0);
    const tax = Number(updated[index]?.invoiceTax || 0);

    updated[index].invoiceValue = qty * price;
    updated[index].invoicetaxAmount = (updated[index].invoiceValue * tax) / 100;
    updated[index].invoiceGrossValueTaxAmount =
      updated[index].invoiceValue + updated[index].invoicetaxAmount;

    setInvoiceItems(updated);
  };

  //handle payment
  const paymentInputChange = ({ target: { name, value } }) => {
    // const errors = {};

    const convertNumberToWords = (num) => {
      if (num === "" || isNaN(num)) return "";
      num = parseFloat(num).toFixed(2); // Ensure two decimal places
      let [rupees, paise] = num.split(".");
      rupees = parseInt(rupees);
      paise = parseInt(paise);

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

      const convertBelowThousand = (n) => {
        if (n < 20) return ones[n];
        if (n < 100)
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
        );
      };

      let words = "";
      let scaleIndex = 0;

      while (rupees > 0) {
        let part = rupees % 1000;
        if (part !== 0) {
          words =
            convertBelowThousand(part) +
            " " +
            scales[scaleIndex] +
            (words ? " " + words : "");
        }
        rupees = Math.floor(rupees / 1000);
        scaleIndex++;
      }

      words = words.trim() ? words.trim() + " Rupees" : "";

      if (paise > 0) {
        let paiseWords = convertBelowThousand(paise) + " Paise";
        words += " and " + paiseWords;
      }

      return words || "Zero Rupees";
    };

    // Handle cashAmount logic
    if (name === "cashAmount") {
      if (!isNaN(value) && value !== "") {
        setCashRequest((prev) => {
          const updated = {
            ...prev,
            cashAmount: value,
            cashAmountInWords: convertNumberToWords(value),
          };

          if (prev.type === "CREDIT") {
            updated.creditAmount = value;
            updated.debitAmount = 0;
          } else if (prev.type === "DEBIT") {
            updated.debitAmount = value;
            updated.creditAmount = 0;
          }

          return updated;
        });
      } else {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: 0,
          cashAmountInWords: "",
          debitAmount: "",
          creditAmount: "",
        }));
      }
    } else {
      // default update for other fields
      setCashRequest((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // setValidation((prev) => ({
    //   ...prev,
    //   [name]: errors[name] || "",
    // }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setInvoiceinfo((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  //=========================================payment
  // let party = [
  //   { id: "V", name: "Vendor", desc: "Vendor" },
  //   { id: "S", name: "Supplier", desc: "Supplier" },
  //   { id: "C", name: "Company", desc: "Company" },
  //   { id: "E", name: "Employee", desc: "Employee" },
  //   { id: "C", name: "Customer", desc: "Customer" },
  // ];

  const paymentModeOptions = [
    { id: 1, code: "EK", name: "Cash", description: "Cash desc" },
    { id: 2, code: "BK", name: "Bank", description: "Bank desc" },
  ];

  const getCompnayBank = [
    //  { id:1,name: "CASH", code: "EK" },
    { id: 2, name: "HDFC BANK", code: "BK" },
    { id: 3, name: "UNION BANK OF INDIA", code: "BK" },
    { id: 4, name: "ICICI BANK OF INDIA", code: "BK" },
  ];
  const getType = [
    { id: 1, code: "DEBIT", name: "Debit", description: "Debit desc" },
    { id: 2, code: "CREDIT", name: "Credit", description: "Credit desc" },
  ];
  // const expenseData = [
  //   { id: 1, name: "Salary", description: "Salary", code: "SL" },
  //   { id: 2, name: "EV Charges", description: "EV Charges", code: "EC" },
  //   {
  //     id: 3,
  //     name: "Vehicle Repair and Maintanance",
  //     description: "Vehicle Repair and Maintanance",
  //     code: "VRM",
  //   },
  //   { id: 4, name: "Diesel", description: "Diesel ", code: "DE" },
  //   {
  //     id: 5,
  //     name: "Telephone and Mobile",
  //     description: "Telephone and Mobile",
  //     code: "TMB",
  //   },
  //   { id: 6, name: "Miscellaneous", description: "Miscellaneous", code: "ME" },
  // ];

  const [getTransactionType, setTransactionType] = useState();
  const [getDropdownData, setDropdownData] = useState("");
  //Customer drop down
  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
        customerBandkDetails: getDropdownData?.customerBandkDetails,
        undercategory: getDropdownData?.undercategory,
        undercategoryCode: getDropdownData?.undercategoryCode,
        receiverContactNumber: getDropdownData?.receiverContactNumber,
      }));
    } else if (getDropdownData?.textField === "party") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "paymentMode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setTransactionType(getDropdownData?.code);
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textField === "expenseName") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "type") {
      setCashRequest((prev) => {
        const updated = {
          ...prev,
          [getDropdownData?.textField]: getDropdownData?.code,
          [getDropdownData?.textDesc]: getDropdownData?.description,
        };

        // ✅ Always use the current cashAmount (not stale prev.cashAmount)
        const currentAmount = Number(prev.cashAmount) || 0;

        if (currentAmount > 0) {
          if (getDropdownData?.code === "CREDIT") {
            updated.creditAmount = currentAmount;
            updated.debitAmount = 0;
          } else if (getDropdownData?.code === "DEBIT") {
            updated.debitAmount = currentAmount;
            updated.creditAmount = 0;
          }
        }

        return updated;
      });

      // setPaymentType(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textField === "transactionMode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
// eslint-disable-next-line
  const paymenthandleInputChange = ({ target: { name, value } }) => {
    const convertNumberToWords = (num) => {
      if (num === "" || isNaN(num)) return "";
      num = parseFloat(num).toFixed(2); // Ensure two decimal places
      let [rupees, paise] = num.split(".");
      rupees = parseInt(rupees);
      paise = parseInt(paise);

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

      const convertBelowThousand = (n) => {
        if (n < 20) return ones[n];
        if (n < 100)
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
        );
      };

      let words = "";
      let scaleIndex = 0;

      while (rupees > 0) {
        let part = rupees % 1000;
        if (part !== 0) {
          words =
            convertBelowThousand(part) +
            " " +
            scales[scaleIndex] +
            (words ? " " + words : "");
        }
        rupees = Math.floor(rupees / 1000);
        scaleIndex++;
      }

      words = words.trim() ? words.trim() + " Rupees" : "";

      if (paise > 0) {
        let paiseWords = convertBelowThousand(paise) + " Paise";
        words += " and " + paiseWords;
      }

      return words || "Zero Rupees";
    };

    // Handle cashAmount logic
    if (name === "cashAmount") {
      if (!isNaN(value) && value !== "") {
        setCashRequest((prev) => {
          const updated = {
            ...prev,
            cashAmount: value,
            cashAmountInWords: convertNumberToWords(value),
          };

          if (prev.type === "CREDIT") {
            updated.creditAmount = value;
            updated.debitAmount = 0;
          } else if (prev.type === "DEBIT") {
            updated.debitAmount = value;
            updated.creditAmount = 0;
          }

          return updated;
        });
      } else {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: 0,
          cashAmountInWords: "",
          debitAmount: "",
          creditAmount: "",
        }));
      }
    } else {
      // default update for other fields
      setCashRequest((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // setValidation((prev) => ({
    //   ...prev,
    //   [name]: errors[name] || "",
    // }));
  };
  const formatSlNo = (n, prefix = "V", width = 4) => {
    const numStr = String(n);
    const padded = numStr.padStart(Math.max(width, numStr.length), "0");
    return `${prefix}${padded}`;
  };
  const generateVouchNumber = async () => {
    const obj = { sequenceName: "VOUCHER" };

    try {
      const res = await ItemServiceV2.newSequenceNumber(obj);

      // Case 1: if your service returns axios-style { status, data }
      if (res?.status === 200 && res.data?.sequenceNo) {
        return res.data.sequenceNo;
      }

      // Case 2: if it directly returns { sequenceNo }
      if (res?.sequenceNo) {
        return res.sequenceNo;
      }

      console.error(">> Error: Invalid sequence response", res);
      return null;
    } catch (error) {
      console.error("Error generating voucher number", error);
      return null;
    }
  };
  //paymment Save

  const handlePaymentSave = async () => {
    setDisabled(true);

    try {
      // Step 1: Create payment request object
      const paymentRequest = {
        data: {
          ...getInvoiceinfo,
          items: invoiceItems,
          deliveryStatus: "Delivery Confirmed", // Fixed typo
          deliveryConfirm: true,
          payment: cashRequest,
          paymentStatus: "Confirmed",
        },
      };

      // Step 2: Process payment
      const paymentResponse = await ItemServiceV2.addPayment(paymentRequest);

      if (paymentResponse?.status !== 200) {
        toast.error(paymentResponse?.message || "Payment processing failed!", {
          duration: 4000,
          position: "top-right",
        });
        return;
      }

      // Step 3: Update GRN details
      const updateResponse = await ItemServiceV2.updateGRNDetail(
        paymentRequest.data
      );

      if (updateResponse?.status !== 200) {
        toast.error(updateResponse?.message || "GRN update failed!", {
          duration: 4000,
          position: "top-right",
        });
        return;
      }

      // Step 4: Process bank entries (EXACTLY as you provided)
      const allPayloads = [];
      const sequenceNo = await generateVouchNumber();
      if (!sequenceNo) {
        toast.error("Failed to generate voucher number");
        return;
      }
      const voucherNumber = formatSlNo(sequenceNo);
      const credit = parseFloat(cashRequest.creditAmount || 0);
      const debit = parseFloat(cashRequest.debitAmount || 0);
      const type = cashRequest.type;

      let originalPayload, reversePayload;

      if (type === "DEBIT") {
        // Company pays (Salary, Expense, etc.)
        // Company credited, Customer debited
        originalPayload = {
          data: {
            voucherNumber,
            customerBandkDetails: cashRequest?.customerBandkDetails || "",
            expensesHead: cashRequest.expensesHead || "",
            companyCode: cashRequest.companyCode || "",
            companyCode2: "",
            companyCodeDesc: cashRequest?.companyCodeDesc || "",
            customerCodeDesc: cashRequest?.customer || "",
            transaction: "Payment",
            transactionType: cashRequest?.paymentModeCode || "",
            customerCode: "",
            bankName: cashRequest.companyBankName || "",
            customrBankName: cashRequest.customrBankName || "",
            companyBank: cashRequest.companyBankName || "",
            transactionMode: cashRequest.transactionMode,
            bankTransactionDate: cashRequest.cashRequestDate || "",
            partyCode: cashRequest.partyCode,
            remarks: cashRequest.paymentPurpose,
            type: "CREDIT", // ✅ Company credited
            items: [
              {
                slNo: "1",
                creditAmount: debit, // ✅ company credited
                debitAmount: 0,
                transaction: "Payment",
              },
            ],
            documentNumber: cashRequest.documentNumber || "",
            invoiceNr: cashRequest.invoiceNr || "",
            invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
            createdBy: cashRequest.createdBy || "",
            createdByName: cashRequest.createdByName || "",
            createdAt: cashRequest.cashRequestDate || "",
            updatedAt: cashRequest.updatedAt || "",
            expenseName: cashRequest.expenseName || "",
            expenseNameCode: cashRequest.expenseNameCode || "",
            generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
            postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          },
        };

        reversePayload = {
          data: {
            voucherNumber,
            customerBandkDetails: cashRequest?.customerBandkDetails || "",
            companyCode: "",
            expensesHead: cashRequest.expensesHead || "",
            companyCode2: cashRequest.companyCode,
            companyCodeDesc: cashRequest?.companyCodeDesc || "",
            customerCodeDesc: cashRequest?.customer || "",
            transaction: "Payment",
            transactionType: cashRequest?.paymentModeCode || "",
            customerCode: cashRequest.customerCode || "",
            customerBankName: cashRequest.customrBankName || "",
            customerBank: cashRequest.customrBankName || "",
            companyBank: cashRequest.companyBankName || "",
            transactionMode: cashRequest.transactionMode || "",
            bankTransactionDate: cashRequest.cashRequestDate || "",
            partyCode: cashRequest.partyCode || "",
            remarks: cashRequest.paymentPurpose,
            type: "DEBIT", // ✅ Customer debited
            items: [
              {
                slNo: "1",
                creditAmount: 0,
                debitAmount: debit, // ✅ driver debited
                transaction: "Payment",
              },
            ],
            documentNumber: cashRequest.documentNumber || "",
            invoiceNr: cashRequest.documentNumber || "",
            invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
            createdBy: cashRequest.createdBy || "",
            createdByName: cashRequest.createdByName || "",
            createdAt: cashRequest.createdAt || "",
            updatedAt: cashRequest.updatedAt || "",
            expenseName: cashRequest.expenseName || "",
            expenseNameCode: cashRequest.expenseNameCode || "",
            generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
            postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          },
        };
      } else if (type === "CREDIT") {
        // Customer pays (Income, Receipt, etc.)
        // Company debited, Customer credited
        originalPayload = {
          data: {
            voucherNumber,
            customerBandkDetails: cashRequest?.customerBandkDetails || "",
            expensesHead: cashRequest.expensesHead || "",
            companyCode: cashRequest.companyCode || "",
            companyCode2: "",
            companyCodeDesc: cashRequest?.companyCodeDesc || "",
            customerCodeDesc: cashRequest?.customer || "",
            transaction: "Receipt",
            transactionType: cashRequest?.paymentModeCode || "",
            customerCode: "",
            bankName: cashRequest.companyBankName || "",
            customrBankName: cashRequest.customrBankName || "",
            companyBank: cashRequest.companyBankName || "",
            transactionMode: cashRequest.transactionMode || "",
            bankTransactionDate: cashRequest.cashRequestDate || "",
            partyCode: cashRequest.partyCode,
            remarks: cashRequest.paymentPurpose,
            type: "DEBIT", // ✅ Company debited
            items: [
              {
                slNo: "1",
                creditAmount: 0,
                debitAmount: credit, // ✅ company debited
                transaction: "Receipt",
              },
            ],
            documentNumber: cashRequest.documentNumber || "",
            invoiceNr: cashRequest.invoiceNr || "",
            invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
            createdBy: cashRequest.createdBy || "",
            createdByName: cashRequest.createdByName || "",
            createdAt: cashRequest.createdAt || "",
            updatedAt: cashRequest.updatedAt || "",
            expenseName: cashRequest.expenseName || "",
            expenseNameCode: cashRequest.expenseNameCode || "",
            generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
            postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          },
        };

        reversePayload = {
          data: {
            voucherNumber,
            customerBandkDetails: cashRequest?.customerBandkDetails || "",
            companyCode: "",
            expensesHead: cashRequest.expensesHead || "",
            companyCode2: cashRequest.companyCode,
            companyCodeDesc: cashRequest?.companyCodeDesc || "",
            customerCodeDesc: cashRequest?.customer || "",
            transaction: "Payment",
            transactionType: cashRequest?.paymentModeCode || "",
            customerCode: cashRequest.customerCode || "",
            customrBankName: cashRequest.customrBankName || "",
            customerBank: cashRequest.customrBankName || "",
            companyBank: cashRequest.companyBankName || "",
            transactionMode: cashRequest.transactionMode || "",
            bankTransactionDate: cashRequest.cashRequestDate || "",
            partyCode: cashRequest.partyCode || "",
            remarks: cashRequest.remarks || "",
            type: "CREDIT", // ✅ Customer credited
            items: [
              {
                slNo: "1",
                creditAmount: credit, // ✅ customer credited
                debitAmount: 0,
                transaction: "Payment",
              },
            ],
            documentNumber: cashRequest.documentNumber || "",
            invoiceNr: cashRequest.documentNumber || "",
            invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
            createdBy: cashRequest.createdBy || "",
            createdByName: cashRequest.createdByName || "",
            createdAt: cashRequest.createdAt || "",
            updatedAt: cashRequest.updatedAt || "",
            expenseName: cashRequest.expenseName || "",
            expenseNameCode: cashRequest.expenseNameCode || "",
            generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
            postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          },
        };
      }

      if (originalPayload) allPayloads.push(originalPayload);
      if (reversePayload) allPayloads.push(reversePayload);

      const failedEntries = [];

      for (const payload of allPayloads) {
        const response = await ItemServiceV2.addInvoice(payload);
        if (!response || response.status !== 200) {
          failedEntries.push(
            payload.data.companyCodeDesc || payload.data.companyCode
          );
        }
      }

      if (failedEntries.length === 0) {
        toast.success("All bank statements uploaded successfully", {
          duration: 3000,
          position: "top-right",
        });

        // Refresh bank statements and expenses
        dispatch(
          getBankStatement({
            queryName: "Customer_BankAndExpenses_List",
            transactionType: "BK",
            page: 1,
            per_page: 10,
          })
        );
        dispatch(
          getCashExpenses({
            queryName: "Customer_BankAndExpenses_List",
            module: "CUSTOMER",
            transactionType: "EK",
            page: 1,
            per_page: 10,
          })
        );
      } else {
        toast.error(`Failed to upload for: ${failedEntries.join(", ")}`, {
          duration: 5000,
          position: "top-right",
        });
      }

      // Step 5: Show success and update UI (only if everything succeeded)
      toast.success("Payment processed successfully!", {
        duration: 2000,
        position: "top-right",
      });

      // Close modal if exists
      if (props.onHide) {
        props.onHide();
      }

      // Refresh dispatch list
      const refreshParams = {
        queryName: "Get_CUST_Dispatch_List",
        page: 1,
        per_page: 10,
      };
      dispatch(getPoDeliverConfirmList(refreshParams));
    } catch (error) {
      console.error("Error in handlePaymentSave:", error);
      toast.error("An unexpected error occurred. Please try again!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  /*   const handlePaymentSave = async () => {
    

    const obj = {
      data: {
        ...getInvoiceinfo,
        items: invoiceItems,

        deliveryStatus: "Deliverey Confirmed",
        deliveryConfirm: true,
        payment: cashRequest,
        paymentStatus: "Confirmed",
      },
    };
    // console.log(">>obj", obj);
    setDisabled(true);
    await ItemServiceV2.addPayment(obj).then((item) => {
      if (item?.status === 200) {
        // handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        let obj = {
          queryName: "Get_CUST_Dispatch_List",
          // module: "PO",
          page: 1,
          per_page: 10,
        };
        dispatch(getPoDeliverConfirmList(obj));

        // navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_CONFIRM);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    await ItemServiceV2.updateGRNDetail(obj.data).then((item) => {
      if (item?.status === 200) {
        // handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
        let obj = {
          queryName: "Get_CUST_Dispatch_List",
          // module: "PO",
          page: 1,
          per_page: 10,
        };
        dispatch(getPoDeliverConfirmList(obj));

        // navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_CONFIRM);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

     const allPayloads = [];
        const sequenceNo = await generateVouchNumber();
        if (!sequenceNo) {
          toast.error("Failed to generate voucher number");
          return;
        }
        const voucherNumber = formatSlNo(sequenceNo);
        const credit = parseFloat(cashRequest.creditAmount || 0);
        const debit = parseFloat(cashRequest.debitAmount || 0);
        const type = cashRequest.type;
    
        let originalPayload, reversePayload;
    
        if (type === "DEBIT") {
          // Company pays (Salary, Expense, etc.)
          // Company credited, Customer debited
          originalPayload = {
            data: {
              voucherNumber,
              customerBandkDetails: cashRequest?.customerBandkDetails || "",
              expensesHead: cashRequest.expensesHead || "",
              companyCode: cashRequest.companyCode || "",
              companyCode2: "",
              companyCodeDesc: cashRequest?.companyCodeDesc || "",
              customerCodeDesc: cashRequest?.customer || "",
              transaction: "Payment",
              transactionType: cashRequest?.paymentModeCode || "",
              customerCode: "",
              bankName: cashRequest.companyBankName || "",
              customrBankName: cashRequest.customrBankName || "",
              companyBank: cashRequest.companyBankName || "",
    
              transactionMode: cashRequest.transactionMode,
              bankTransactionDate: cashRequest.cashRequestDate || "",
              partyCode: cashRequest.partyCode,
              remarks: cashRequest.paymentPurpose,
              type: "CREDIT", // ✅ Company credited
              items: [
                {
                  slNo: "1",
                  creditAmount: debit, // ✅ company credited
                  debitAmount: 0,
                  transaction: "Payment",
                },
              ],
              documentNumber: cashRequest.documentNumber || "",
              invoiceNr: cashRequest.invoiceNr || "",
              invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
              createdBy: cashRequest.createdBy || "",
              createdByName: cashRequest.createdByName || "",
              createdAt: cashRequest.cashRequestDate || "",
              updatedAt: cashRequest.updatedAt || "",
              expenseName: cashRequest.expenseName || "",
              expenseNameCode: cashRequest.expenseNameCode || "",
              generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
              postingDate: cashRequest?.cashRequestDate || getTodaysData(),
            },
          };
    
          reversePayload = {
            data: {
              voucherNumber,
              customerBandkDetails: cashRequest?.customerBandkDetails || "",
              companyCode: "",
              expensesHead: cashRequest.expensesHead || "",
              companyCode2: cashRequest.companyCode,
              companyCodeDesc: cashRequest?.companyCodeDesc || "",
              customerCodeDesc: cashRequest?.customer || "",
              // transaction: "Receipt",
              transaction: "Payment",
              transactionType: cashRequest?.paymentModeCode || "",
              customerCode: cashRequest.customerCode || "",
              customerBankName: cashRequest.customrBankName || "",
              customerBank: cashRequest.customrBankName || "",
              companyBank: cashRequest.companyBankName || "",
              transactionMode: cashRequest.transactionMode || "",
              bankTransactionDate: cashRequest.cashRequestDate || "",
              partyCode: cashRequest.partyCode || "",
              remarks: cashRequest.paymentPurpose,
              type: "DEBIT", // ✅ Customer debited
              items: [
                {
                  slNo: "1",
                  creditAmount: 0,
                  debitAmount: debit, // ✅ driver debited
                  // transaction: "Receipt",
                  transaction: "Payment",
                },
              ],
              documentNumber: cashRequest.documentNumber || "",
              invoiceNr: cashRequest.documentNumber || "",
              invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
              createdBy: cashRequest.createdBy || "",
              createdByName: cashRequest.createdByName || "",
              createdAt: cashRequest.createdAt || "",
              updatedAt: cashRequest.updatedAt || "",
              expenseName: cashRequest.expenseName || "",
              expenseNameCode: cashRequest.expenseNameCode || "",
              generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
              postingDate: cashRequest?.cashRequestDate || getTodaysData(),
            },
          };
        } else if (type === "CREDIT") {
          // Customer pays (Income, Receipt, etc.)
          // Company debited, Customer credited
          originalPayload = {
            data: {
              voucherNumber,
              customerBandkDetails: cashRequest?.customerBandkDetails || "",
              expensesHead: cashRequest.expensesHead || "",
              companyCode: cashRequest.companyCode || "",
              companyCode2: "",
              companyCodeDesc: cashRequest?.companyCodeDesc || "",
              customerCodeDesc: cashRequest?.customer || "",
              transaction: "Receipt",
              transactionType: cashRequest?.paymentModeCode || "",
              customerCode: "",
              bankName: cashRequest.companyBankName || "",
              customrBankName: cashRequest.customrBankName || "",
              companyBank: cashRequest.companyBankName || "",
              transactionMode: cashRequest.transactionMode || "",
              bankTransactionDate: cashRequest.cashRequestDate || "",
              partyCode: cashRequest.partyCode,
              remarks: cashRequest.paymentPurpose,
              type: "DEBIT", // ✅ Company debited
              items: [
                {
                  slNo: "1",
                  creditAmount: 0,
                  debitAmount: credit, // ✅ company debited
                  transaction: "Receipt",
                },
              ],
              documentNumber: cashRequest.documentNumber || "",
              invoiceNr: cashRequest.invoiceNr || "",
              invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
              createdBy: cashRequest.createdBy || "",
              createdByName: cashRequest.createdByName || "",
              createdAt: cashRequest.createdAt || "",
              updatedAt: cashRequest.updatedAt || "",
              expenseName: cashRequest.expenseName || "",
              expenseNameCode: cashRequest.expenseNameCode || "",
              generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
              postingDate: cashRequest?.cashRequestDate || getTodaysData(),
            },
          };
    
          reversePayload = {
            data: {
              voucherNumber,
              customerBandkDetails: cashRequest?.customerBandkDetails || "",
              companyCode: "",
              expensesHead: cashRequest.expensesHead || "",
              companyCode2: cashRequest.companyCode,
              companyCodeDesc: cashRequest?.companyCodeDesc || "",
              customerCodeDesc: cashRequest?.customer || "",
              transaction: "Payment",
              transactionType: cashRequest?.paymentModeCode || "",
              customerCode: cashRequest.customerCode || "",
              customrBankName: cashRequest.customrBankName || "",
              customerBank: cashRequest.customrBankName || "",
              companyBank: cashRequest.companyBankName || "",
              transactionMode: cashRequest.transactionMode || "",
              bankTransactionDate: cashRequest.cashRequestDate || "",
              partyCode: cashRequest.partyCode || "",
              remarks: cashRequest.remarks || "",
              type: "CREDIT", // ✅ Customer credited
              items: [
                {
                  slNo: "1",
                  creditAmount: credit, // ✅ customer credited
                  debitAmount: 0,
                  transaction: "Payment",
                },
              ],
              documentNumber: cashRequest.documentNumber || "",
              invoiceNr: cashRequest.documentNumber || "",
              invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
              createdBy: cashRequest.createdBy || "",
              createdByName: cashRequest.createdByName || "",
              createdAt: cashRequest.createdAt || "",
              updatedAt: cashRequest.updatedAt || "",
              expenseName: cashRequest.expenseName || "",
              expenseNameCode: cashRequest.expenseNameCode || "",
              generatedDate: cashRequest?.cashRequestDate || getTodaysData(),
              postingDate: cashRequest?.cashRequestDate || getTodaysData(),
            },
          };
        }
    
        if (originalPayload) allPayloads.push(originalPayload);
        if (reversePayload) allPayloads.push(reversePayload);
        setDisabled(true);
        const failedEntries = [];
    
        try {
          for (const payload of allPayloads) {
            const response = await ItemServiceV2.addInvoice(payload);
            if (!response || response.status !== 200) {
              failedEntries.push(
                payload.data.companyCodeDesc || payload.data.companyCode
              );
            }
          }
    
          if (failedEntries.length === 0) {
            toast.success("All bank statements uploaded successfully", {
              duration: 3000,
              position: "top-right",
            });
            dispatch(
              getBankStatement({
                queryName: "Customer_BankAndExpenses_List",
                transactionType: "BK",
                page: 1,
                per_page: 10,
              })
            );
            dispatch(
              getCashExpenses({
                queryName: "Customer_BankAndExpenses_List",
                module: "CUSTOMER",
                transactionType: "EK",
                page: 1,
                per_page: 10,
              })
            );
            // setShowDataModal(false);
          } else {
            toast.error(`Failed to upload for: ${failedEntries.join(", ")}`, {
              duration: 5000,
              position: "top-right",
            });
          }
        } catch (err) {
          toast.error("Something went wrong during upload", {
            duration: 5000,
            position: "top-right",
          });
        } finally {
          setDisabled(false);
        }

  }; */
  //payment
  useEffect(() => {
    const loadMasterData = async () => {
      let obj1 = {
        codeType: "companyCode",
      };
      await ItemService.getMasterData(obj1).then((item) => {
        // console.log(">> item! companyCode title", item);
        if (item?.status === 200) {
          setCompanyCode(item?.data);
        } else {
          setCompanyCode([]);
          console.log(">> Error: Loading Company Code");
        }
      });

      let obj2 = {
        queryName: "AllCustomers",
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              type: "EMP",
            },
          ],
        },
      };

      await ItemService.generateCustomerQuery(obj2).then((item) => {
        if (item?.status === 200) {
          const transformed = item.data.map((cust) => ({
            id: cust.customerCode,
            name: cust.organisationName,
            desc: cust.organisationName,
            customerBandkDetails: cust.bandkDetails?.[0] || null,
            undercategory: cust?.undercategory,
            undercategoryCode: cust?.undercategoryCode,
            receiverContactNumber: cust?.mobileNr,
          }));
          setCustomer(transformed);
        } else {
          setCustomer([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    };
    loadMasterData();
  }, []);

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Goods Received Confirmation - {getInvoiceinfo?.purchasingDocumentNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* 01 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">HD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Header Details</span>
                  <span className="subHeaderTitle">details</span>
                </Col>

                <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                  {/* <Col
                    xs={6}
                    md={6}
                    lg={6}
                    className="d-flex justify-content-end mr-2 mt-1"
                  >
                    <button className="btnTable" onClick={handlePrint}>Print Invoice</button>
                    <div style={{ display: "none" }}>
                      <PrintInvoice ref={contentRef} data={printInvoiceData} />
                    </div>
                  </Col> */}
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Number"
                      name="purchasingDocumentNr"
                      placeholder=""
                      value={getInvoiceinfo?.purchasingDocumentNr || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Date"
                      name="purchasingDocumentDate"
                      placeholder=""
                      value={
                        formatDate(getInvoiceinfo?.purchasingDocumentDate) || ""
                      }
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Currency"
                      placeholder=""
                      name="currency"
                      id="currency"
                      value={getInvoiceinfo?.currency || ""}
                      // onChange={onInputChange}
                      disabled={true}
                      // required={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Code"
                      name="vendorCode"
                      placeholder=""
                      value={getInvoiceinfo?.AssociateNumber || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Name"
                      name="organisationName"
                      placeholder=""
                      value={getInvoiceinfo?.organisationName || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Payment Terms"
                      name="paymentTerms"
                      placeholder=""
                      value={getInvoiceinfo?.paymentTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Code "
                      name="companyCodeCode"
                      id="companyCodeCode"
                      value={getInvoiceinfo?.companyCodeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Purchse Type"
                      name="productType"
                      placeholder=""
                      value={getInvoiceinfo?.productType || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Item Total Amount"
                      placeholder=""
                      name="totalQtnItemValue"
                      id="totalQtnItemValue"
                      value={totalQtnItemValue || ""}
                      disabled={true}
                      // required={true}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Tax Amount"
                      placeholder=""
                      name="totalTaxAmount"
                      id="totalTaxAmount"
                      value={totalTaxAmount || ""}
                      // error={validation.truckNo || ""}
                      // onChange={handleInputChange}
                      disabled={true}
                      required={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Purchase Net Value"
                      placeholder=""
                      name="totalGrossValue"
                      id="totalGrossValue"
                      value={totalGrossValue || ""}
                      // error={validation.truckNo || ""}
                      // onChange={handleInputChange}
                      disabled={true}
                    />
                  </Col>
                  {/*   <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding mt-4 pt-3"
                  >
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                        Header Text
                      </label>
                      <span
                        style={{ marginLeft: "15px" }}
                        onClick={() =>
                          // headerTextShowModal(getHeaderData?.headerTextData)
                          headerTextShowModal(getInvoiceinfo?.headerTextData)
                        }
                      >
                        <i className="bi bi-calendar2-week iconTable"></i>
                      </span>
                      <span className="suppliersIcon">
                        {" "}
                        {getInvoiceinfo?.headerTextData?.length || 0}{" "}
                      </span>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </div>
          </div>
        </div>
        {/*02 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={8} lg={8}>
                  <span className="headerTitle">Items</span>
                  <span className="subHeaderTitle">Items details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={
                            getInvoiceinfo?.purchaseTypeCode === "MAT"
                              ? columns
                              : getInvoiceinfo?.purchaseTypeCode === "SER"
                              ? columnsService
                              : getInvoiceinfo?.purchaseTypeCode === "SA"
                              ? columnsSchedule
                              : columns
                          }
                          data={invoiceItems}
                          // progressPending={orderSchedulingData?.status}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          // paginationTotalRows={orderSchedulingTable.total}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          // selectableRows
                          onSelectedRowsChange={handleSelectedRowsChange}
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* 03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={8} lg={8}>
                  <span className="headerTitle">Invoice</span>
                  <span className="subHeaderTitle">Invoice Details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Qty"
                            placeholder=""
                            name="totalGrossValue"
                            id="totalGrossValue"
                            value={
                              totals?.totalInvoiceQty ||
                              getInvoiceinfo?.totalInvoiceQty ||
                              ""
                            }
                            // error={validation.truckNo || ""}
                            // onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Price"
                            placeholder=""
                            name="totalInvoicePrice"
                            id="totalInvoicePrice"
                            value={
                              totals?.totalInvoicePrice ||
                              getInvoiceinfo?.totalInvoicePrice ||
                              ""
                            }
                            // error={validation.truckNo || ""}
                            // onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Value"
                            placeholder=""
                            name="totalInvoiceValue"
                            id="totalInvoiceValue"
                            value={
                              totals?.totalInvoiceValue ||
                              getInvoiceinfo?.totalInvoiceValue ||
                              ""
                            }
                            // error={validation.truckNo || ""}
                            // onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Tax Amount"
                            placeholder=""
                            name="totalInvoicetaxAmount"
                            id="totalInvoicetaxAmount"
                            value={
                              totals?.totalInvoicetaxAmount ||
                              getInvoiceinfo?.totalInvoicetaxAmount ||
                              ""
                            }
                            // error={validation.truckNo || ""}
                            // onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Invoice Gross"
                            placeholder=""
                            name="totalInvoiceGrossValueTaxAmount"
                            id="totalInvoiceGrossValueTaxAmount"
                            value={
                              totals?.totalInvoiceGrossValueTaxAmount ||
                              getInvoiceinfo?.totalInvoiceGrossValueTaxAmount ||
                              ""
                            }
                            // error={validation.truckNo || ""}
                            // onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>

                        {!getDisabledStatus && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="invoiceAttachment"
                              name="invoiceAttachment"
                              label="Invoice Attachment"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              // required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={getInvoiceinfo?.invoiceAttachment || ""}
                            />
                          </Col>
                        )}

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <div
                            style={{ width: "100%" }}
                            className="d-flex justify-content-center"
                          >
                            {getInvoiceinfo?.invoiceAttachment ? (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="invoiceAttachment"
                                onClick={() =>
                                  handleViewFile(
                                    getInvoiceinfo?.invoiceAttachment
                                  )
                                }
                              />
                            ) : (
                              <>--</>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* 04 */}
        {grnNumber !== "" && (
          <>
            {/*       <div className="accordion mb-4" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                    <span className="iconLogo">PD</span>
                  </Col>

                  <Col xs={4} md={4} lg={4}>
                    <span className="headerTitle"> Payment</span>
                    <span className="subHeaderTitle">Payment details</span>
                  </Col>
                </Row>
              </h2>

              <div>
                <div className="accordion-body">
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              type="date"
                              label="Received Date"
                              name="cashRequestDate"
                              id="cashRequestDate"
                              value={cashRequest?.cashRequestDate}
                              onChange={paymenthandleInputChange}
                              disabled={getPaymentdisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Company Code "
                              name="companyCodeCode"
                              id="companyCodeCode"
                              value={getInvoiceinfo?.companyCodeCode}
                              disabled={true}
                            />

                            
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Party"
                              placeholder=""
                              data={party}
                              id="party"
                              iconClassName="dropdownIcon"
                              name="party"
                              code="partyCode"
                              description="partyDesc"
                              setValue={cashRequest?.party || ""}
                              getvalue={setDropdownData}
                              disabled={true}
                              // required={true}
                              // error={validation.party}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Mode"
                              placeholder=""
                              data={paymentModeOptions}
                              id="paymentMode"
                              iconClassName="dropdownIcon"
                              name="paymentMode"
                              code="paymentModeCode"
                              description="paymentModeDesc"
                              setValue={cashRequest?.paymentMode || ""}
                              getvalue={setDropdownData}
                              disabled={getPaymentdisable}
                              // required={true}
                              // error={validation.companyCode}
                            />
                          </Col>
                          {getTransactionType === "BK" && (
                            <>
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >

                                <ComboboxField
                                  label="Company Bank Name"
                                  placeholder=""
                                  data={getCompnayBank}
                                  id="companyBankName"
                                  iconClassName="dropdownIcon"
                                  name="companyBankName"
                                  code="companyBankNameCode"
                                  description="companyBankNameDesc"
                                  setValue={cashRequest?.companyBankName || ""}
                                  getvalue={setDropdownData}
                                  disabled={getPaymentdisable}
                                  // required={true}
                                  // error={validation.companyCode}
                                />
                              </Col>
                            </>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Transaction Mode"
                              placeholder=""
                              name="transactionMode"
                              id="transactionMode"
                              // error={validation.transactionMode || ""}
                              value={cashRequest?.transactionMode || ""}
                              onChange={paymenthandleInputChange}
                              disabled={getPaymentdisable}
                            />
                          </Col>
                          {getTransactionType === "EK" && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Expenses Head"
                                placeholder=""
                                name="expensesHead"
                                id="expensesHead"
                                // error={validation.expensesHead || ""}
                                value={cashRequest?.expensesHead || ""}
                                onChange={paymenthandleInputChange}
                                disabled={getPaymentdisable}
                              />
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Amount (INR)"
                              placeholder="Enter amount"
                              name="cashAmount"
                              id="cashAmount"
                              // error={validation.cashAmount || ""}
                              value={cashRequest?.cashAmount || ""}
                              onChange={paymenthandleInputChange}
                              disabled={getPaymentdisable}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Cash Amount in Words"
                              placeholder="Cash Amount in Words"
                              name="cashAmountInWords"
                              id="cashAmountInWords"
                              value={cashRequest?.cashAmountInWords || ""}
                              disabled={true} // Read-only field
                            />
                          </Col>
                          {getTransactionType === "BK" && (
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Vendor BankName"
                                name="customrBankName"
                                id="customrBankName"
                                value={cashRequest?.customrBankName}
                                // error={validation.receivedBy || ""}
                                onChange={paymenthandleInputChange || ""}
                                // disabled={true}
                                disabled={getPaymentdisable}
                              />
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Transaction Date"
                              name="bankTransactionDate"
                              id="bankTransactionDate"
                              type="date"
                              value={cashRequest?.bankTransactionDate}
                              // error={validation.receivedBy || ""}
                              onChange={paymenthandleInputChange || ""}
                              // disabled={true}
                              disabled={getPaymentdisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor Name"
                              name="organisationName"
                              placeholder=""
                              value={getInvoiceinfo?.organisationName || ""}
                              disabled={true}
                            />

                           
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Vendor Code"
                              name="vendorCode"
                              placeholder=""
                              value={getInvoiceinfo?.AssociateNumber || ""}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Venoder contact number"
                              name="receiverContactNumber"
                              id="receiverContactNumber"
                              value={cashRequest?.receiverContactNumber || ""}
                              // error={validation.receiverContactNumber || ""}
                              onChange={paymenthandleInputChange}
                              // disabled={true}
                              disabled={getPaymentdisable}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Type"
                              placeholder=""
                              data={getType}
                              id="type"
                              iconClassName="dropdownIcon"
                              name="type"
                              code="typeCode"
                              description="typeCodeDesc"
                              setValue={cashRequest?.type || ""}
                              getvalue={setDropdownData}
                              disabled={getPaymentdisable}
                              // required={true}
                              // error={validation.type}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Debit Amount"
                              name="debitAmount"
                              id="debitAmount"
                              value={cashRequest?.debitAmount ?? 0}
                              // error={validation.type || ""}
                              onChange={paymenthandleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Credit Amount"
                              name="creditAmount"
                              id="creditAmount"
                              value={cashRequest?.creditAmount ?? 0}
                              // error={validation.type || ""}
                              onChange={paymenthandleInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commLeftRightPadding"
                          >
 <InputField
                              className="inputBox"
                              label="Payment Type"
                              name="paymentType"
                              id="paymentType"
                              value={cashRequest?.paymentType ?? 0}
                              // error={validation.type || ""}
                              onChange={paymenthandleInputChange}
                              disabled={true}
                            />

                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Payment Purpose"
                              name="paymentPurpose"
                              id="paymentPurpose"
                              value={cashRequest?.paymentPurpose}
                              // error={validation.paymentPurpose || ""}
                              onChange={paymenthandleInputChange}
                              // disabled={true}
                              disabled={getPaymentdisable}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div> */}

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PR</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle"> Payment</span>
                      <span className="subHeaderTitle">
                        Information about Paymnent transaction
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div>
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="date"
                                label="Created Date"
                                name="cashRequestDate"
                                id="cashRequestDate"
                                value={cashRequest?.cashRequestDate}
                                onChange={paymentInputChange}
                                // disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Company Name"
                                placeholder=""
                                data={getCompanyCode}
                                id="companyCode"
                                iconClassName="dropdownIcon"
                                name="companyCode"
                                code="companyCode"
                                description="companyCodeDesc"
                                setValue={cashRequest?.companyCode || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.companyCode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Customer/Vendor/Employee"
                                placeholder=""
                                data={getCustomer}
                                id="customer"
                                iconClassName="dropdownIcon"
                                name="customer"
                                code="customerCode"
                                description="customerCodeDesc"
                                setValue={cashRequest?.customerCode || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.customerCode}
                              />
                            </Col>
                            {getTransactionType === "BK" && (
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Customer/Vendor/Employee BankName"
                                  name="customrBankName"
                                  id="customrBankName"
                                  value={
                                    cashRequest?.customerBandkDetails
                                      ?.bankAccountNumber
                                  }
                                  // error={validation.receivedBy || ""}
                                  onChange={paymentInputChange || ""}
                                  disabled={true}
                                />
                              </Col>
                            )}

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Payment Mode"
                                placeholder=""
                                data={paymentModeOptions}
                                id="paymentMode"
                                iconClassName="dropdownIcon"
                                name="paymentMode"
                                code="paymentModeCode"
                                description="paymentModeDesc"
                                setValue={cashRequest?.paymentMode || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.companyCode}
                              />
                            </Col>
                            {getTransactionType === "BK" && (
                              <>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* comapny bank name */}

                                  <ComboboxField
                                    label="Company Bank Name"
                                    placeholder=""
                                    data={getCompnayBank}
                                    id="companyBankName"
                                    iconClassName="dropdownIcon"
                                    name="companyBankName"
                                    code="companyBankNameCode"
                                    description="companyBankNameDesc"
                                    setValue={
                                      cashRequest?.companyBankName || ""
                                    }
                                    getvalue={setDropdownData}
                                    required={true}
                                    // error={validation.companyCode}
                                  />
                                </Col>
                              </>
                            )}
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Cash/Bank Transaction Date"
                                name="bankTransactionDate"
                                id="bankTransactionDate"
                                type="date"
                                value={cashRequest?.bankTransactionDate}
                                // error={validation.receivedBy || ""}
                                onChange={paymentInputChange || ""}
                                // disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Transaction Type"
                                placeholder=""
                                data={transactionType}
                                id="transactionMode"
                                iconClassName="dropdownIcon"
                                name="transactionMode"
                                code="transactionModeCode"
                                description="transactionModeDesc"
                                setValue={cashRequest?.transactionMode || ""}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.companyCode}
                              />
                            </Col>
                            {getTransactionType === "BK" &&
                              cashRequest?.transactionMode === "CHEQUE" && (
                                <>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Cheque Number"
                                      placeholder=""
                                      name="chequeNumber"
                                      id="chequeNumber"
                                      // error={validation.chequeNumber || ""}
                                      value={cashRequest?.chequeNumber || ""}
                                      onChange={paymentInputChange}
                                    />
                                  </Col>
                                </>
                              )}

                            {getTransactionType === "BK" &&
                              (cashRequest?.transactionMode === "NEFT" ||
                                cashRequest?.transactionMode === "RTGS" ||
                                cashRequest?.transactionMode === "UPI") && (
                                <>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="  NEFT/RTGS/UPI/CASH"
                                      placeholder=""
                                      name="transactionType"
                                      id="transactionType"
                                      // error={validation.transactionType || ""}
                                      value={cashRequest?.transactionType || ""}
                                      onChange={paymentInputChange}
                                    />
                                  </Col>
                                </>
                              )}

                            {getTransactionType === "BK" &&
                              cashRequest?.transactionMode === "CHEQUE" && (
                                <>
                                  <Col
                                    xs={12}
                                    md={6}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Cheque Date"
                                      placeholder=""
                                      type="date"
                                      min={1990}
                                      name="chequeDate"
                                      id="chequeDate"
                                      // error={validation.chequeDate || ""}
                                      value={cashRequest?.chequeDate || ""}
                                      onChange={paymentInputChange}
                                    />
                                  </Col>
                                </>
                              )}

                            {getTransactionType === "EK" && (
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Cash/Expenses Details"
                                  placeholder=""
                                  name="expensesHead"
                                  id="expensesHead"
                                  // error={validation.expensesHead || ""}
                                  value={cashRequest?.expensesHead || ""}
                                  onChange={paymentInputChange}
                                />
                              </Col>
                            )}
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Amount (INR)"
                                placeholder="Enter amount"
                                name="cashAmount"
                                id="cashAmount"
                                // error={validation.cashAmount || ""}
                                value={cashRequest?.cashAmount || ""}
                                onChange={paymentInputChange}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Cash Amount in Words"
                                placeholder="Cash Amount in Words"
                                name="cashAmountInWords"
                                id="cashAmountInWords"
                                value={cashRequest?.cashAmountInWords || ""}
                                disabled={true} // Read-only field
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Contact Number"
                                name="receiverContactNumber"
                                id="receiverContactNumber"
                                value={cashRequest?.receiverContactNumber || ""}
                                // error={validation.receiverContactNumber || ""}
                                onChange={paymentInputChange}
                                // disabled={true}
                              />
                            </Col>
                            {!hide && (
                              <>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <ComboboxField
                                    label="Type"
                                    placeholder=""
                                    data={getType}
                                    id="type"
                                    iconClassName="dropdownIcon"
                                    name="type"
                                    code="typeCode"
                                    description="typeCodeDesc"
                                    setValue={cashRequest?.typeCodeDesc || ""}
                                    getvalue={setDropdownData}
                                    // required={true}
                                    disabled={true}
                                    // error={validation.type}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={6}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Debit Amount"
                                    name="debitAmount"
                                    id="debitAmount"
                                    value={cashRequest?.debitAmount ?? 0}
                                    // error={validation.type || ""}
                                    onChange={paymentInputChange}
                                    disabled={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Credit Amount"
                                    name="creditAmount"
                                    id="creditAmount"
                                    value={cashRequest?.creditAmount ?? 0}
                                    // error={validation.type || ""}
                                    onChange={paymentInputChange}
                                    disabled={true}
                                  />
                                </Col>
                              </>
                            )}

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Expense Type"
                                placeholder=""
                                data={expenseData}
                                id="expenseName"
                                iconClassName="dropdownIcon"
                                name="expenseName"
                                code="expenseNameCode"
                                description="expenseNameDesc"
                                setValue={cashRequest?.expenseName || ""}
                                getvalue={setDropdownData}
                                // required={true}
                                // error={validation.expenseName}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <TextAreaField
                                className="inputBox"
                                label="Payment Purpose"
                                name="paymentPurpose"
                                id="paymentPurpose"
                                value={cashRequest?.paymentPurpose}
                                // error={validation.paymentPurpose || ""}
                                onChange={paymentInputChange}
                                // disabled={true}
                              />
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {grnNumber !== "" && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>

            {getPaymentdisable && (
              <Col lg={2} className="d-flex justify-content-end mt-2">
                <button
                  className="btnTable"
                  onClick={handlePaymentSave}
                  disabled={disable}
                >
                  Submit Payment
                </button>
              </Col>
            )}
          </Row>
        )}
        {!getDisabledStatus && grnNumber === "" && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end mt-2"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end mt-2">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disable}
              >
                Submit
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
      {/* <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        // columns={getItemLevelColumns}
        // data={getItemLevelData}
        title={getModalTitle}
      /> */}
      {/* <CommonItemLevelDatatableModal
        // show={itemLevelModalShow}
        // onHide={() => itemLevelHideModal()}
        // columns={getItemLevelColumns}
        // data={getItemLevelData}
        title={getModalTitle}
      /> */}
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </Modal>
  );
});

export default DispatchPurchaseOrderModal;
